export enum ContactPointViewItemType {
    Organisation = '1',
    ContactPoint = '2',
    ContactGroup = '3',
    Static = '4',
}
